import { defineSemanticTokens } from "@chakra-ui/react/styled-system";

export const radii = defineSemanticTokens.radii({});
